import React from "react";
import { Link } from "react-router-dom";
import { Crown, Shield, Zap, Award } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/5 bg-slate-950/60">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 rounded-lg gold-btn flex items-center justify-center">
              <Crown className="w-4 h-4" />
            </span>
            <span className="heading text-xl font-extrabold gold-gradient-text">Rifa RMC</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            A plataforma de rifas online da nossa região. Prêmios de valor agregado com transparência absoluta.
          </p>
        </div>
        <div>
          <h4 className="text-amber-200 text-sm uppercase tracking-widest mb-4">Rifas</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/rifas" className="hover:text-amber-200 transition-colors">Ativas</Link></li>
            <li><Link to="/ganhadores" className="hover:text-amber-200 transition-colors">Encerradas</Link></li>
            <li><Link to="/ganhadores" className="hover:text-amber-200 transition-colors">Sorteios realizados</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-amber-200 text-sm uppercase tracking-widest mb-4">Sobre</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/como-funciona" className="hover:text-amber-200 transition-colors">Como funciona</Link></li>
            <li><Link to="/ganhadores" className="hover:text-amber-200 transition-colors">Ganhadores</Link></li>
            <li><Link to="/suporte" className="hover:text-amber-200 transition-colors">Suporte</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-amber-200 text-sm uppercase tracking-widest mb-4">Segurança</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Shield className="w-4 h-4 text-emerald-400" /> PIX Criptografado</li>
            <li className="flex items-center gap-2"><Award className="w-4 h-4 text-amber-300" /> Sorteio Seguro</li>
            <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-amber-300" /> Cotas em segundos</li>
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-slate-500 py-6 border-t border-white/5">
        © 2026 Rifa RMC — Todos os direitos reservados.
      </div>
    </footer>
  );
}
